var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.FormComponent, _vm._b({
    tag: "component",
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on,
          loading = _ref.loading,
          isNext = _ref.isNext;
        return [_vm._t("activator", null, null, {
          attrs,
          on,
          loading,
          isNext
        })];
      }
    }], null, true),
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'component', {
    program: _vm.program
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }